import { LinearProgress, Stack } from '@mui/material';
import useGlobalStyles from '../../../hooks/useGlobalStyles';
import Logo from '../Logo/Logo';
import StyledLoading from './StyledLoading';

const Loading = () => {
  useGlobalStyles('main', 'circular-gradient-background', true);

  return (
    <StyledLoading>
      <Logo />
      <Stack sx={{ width: '10%' }} spacing={2}>
        <LinearProgress color="primary" />
      </Stack>
    </StyledLoading>
  );
};

export default Loading;
